module.exports = __webpack_public_path__ + "download/static/img/251208.9c8553c6.png";